<template>
  <div class="navigator">
    <button class="navigator__prev--button" @click="decrement">
      <svgicon
        class="icon"
        name="arrow-left"
        color="var(--ui-white)"
        height="2.5rem"
        width="2.5rem"
      />
      <span v-if="$tvaMq === 'tablet'">prev</span>
    </button>
    <div class="navigator--title">
      <p class="navigator--title__text">{{ title }}</p>
    </div>
    <button
      :class="['navigator__next--button', { hidden: landingIndex === 5 }]"
      @click="increment"
    >
      <svgicon
        class="icon"
        name="arrow-right"
        color="var(--ui-white)"
        height="2.5rem"
        width="2.5rem"
      />
      <span v-if="$tvaMq === 'tablet'">next</span>
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    prev: {
      type: Object,
      required: false,
    },
    next: {
      type: Object,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    landingIndex: {
      type: Number,
      required: false,
    },
  },
  methods: {
    ...mapActions({
      increment: "scroller/increment",
      decrement: "scroller/decrement",
    }),
  },
};
</script>

<style lang="scss" scoped>
.navigator {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 toRem(11);

  .icon {
    min-width: 2.5rem;
    min-height: 2.5rem;

    // &.hidden {
    //   visibility: hidden;
    // }
  }

  &__prev--button {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    @include link-M;
    &.hidden {
      visibility: hidden;
    }
  }

  &__next--button {
    @extend .navigator__prev--button;
    flex-direction: row-reverse;
  }

  &--title {
    position: relative;
    width: 100%;
    height: 80px;
    &__text {
      white-space: wrap;
      text-align: center;
      @include slider-M;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}

.tablet {
  .navigator {
    align-items: flex-end;
    height: 10.6vh;
    &--title {
      height: fit-content;
      &__text {
        @include slider-M-tablet;
      }
    }
  }
}
</style>
